export default defineNuxtPlugin({
    name: 'favoritesCache',

    setup() {
        const { isLoggedIn } = useAuthUtils();

        const favoriteAssets = ref<Set<string> | null>(null);

        const isFavoriteAssetsInitialized = computed(() => favoriteAssets.value !== null);

        const isFavoriteAsset = (assetId: string): boolean => isLoggedIn.value && !!favoriteAssets.value?.has(assetId);

        const setFavoriteAssets = (assetIds: string[]): void => {
            favoriteAssets.value = new Set(assetIds);
        };

        const addFavoriteAsset = (assetId: string): void => {
            favoriteAssets.value?.add(assetId);
        };

        const deleteFavoriteAsset = (assetId: string): void => {
            favoriteAssets.value?.delete(assetId);
        };

        watch(isLoggedIn, value => {
            if (!value) favoriteAssets.value = null;
        });

        return {
            provide: {
                favoritesCache: {
                    isFavoriteAssetsInitialized,
                    isFavoriteAsset,
                    setFavoriteAssets,
                    addFavoriteAsset,
                    deleteFavoriteAsset,
                },
            },
        };
    },
});
